import { defineComponent } from 'vue';
import { QCheckbox } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponentMixin from './BaseComponentMixin.jsx';

const CHECKBOX_CHANGE_CODE_BEHIND = {
    actionsKey: 'OnChangeActions',
    handlerSuffix: '_Change',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your value change handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'checkbox-dsgn',
    mixins: [BaseComponentMixin],
    components: { QCheckbox },
    computed: {
        label() {
            return this.controlData?.Label || 'Checkbox';
        },
        checked() {
            return this.controlData?.Default === true || this.controlData?.Default === 'true';
        },
        containerStyle() {
            return {
                ...utils.getSize(this.controlData?.SizeOptions, this.parentType, this.$parent),
                ...utils.getStyleHints(this.controlData?.StyleHints, this),
            };
        },
    },
    methods: {
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, CHECKBOX_CHANGE_CODE_BEHIND);
        },
    },
    render() {
        if (!this.controlData)
            return null;

        return (
            <div
                class={{ 'c-Checkbox': true, 'designer-container': true, selected: this.selected$ }}
                style={this.containerStyle}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ 'designer-container-hovering': true, 'designer-container-selected': this.selected$ }} />
                <QCheckbox
                    dense
                    disable
                    modelValue={this.checked}
                    label={this.label}
                />
            </div>
        );
    },
});
